import { Component } from "@angular/core";
import { MdDialog, MdDialogRef } from "@angular/material";
import { GenerateGltLicenseComponent } from "./generate-glt-license/generate-glt-license.component";
import { LicenseService } from "../../services/LicenseService";
import { AppLoaderService } from "../../../services/app-loader/app-loader.service";
import { apply } from "core-js/fn/reflect";
import { ActivatedRoute, Router } from "@angular/router";
import { AdalService } from "../../shared/adal.service";
import Swal from "sweetalert2";
import { ExportToCSVService } from "../../services/ExportToCSVService";
import { PagerService } from "../../services/PagerService";
import { UserService } from "../../services/UserService";

@Component({
    selector:'license-glt',
    template:require('./glt.component.html'),
    styles:[require('./glt.component.css')],
})
export class LicenseModuleGltComponent{
    error="";
    public dialogRef :MdDialogRef<GenerateGltLicenseComponent>
    originalGltLicenseDisplayDetail=[];
    gltLicenseDisplayDetail=[];
    pager:any={};
    pagedItems=[];
    IsAddEdit;
    IsDelete;
    ProductId;
    currentSortColumn='';
    currentSortOrder='';
    constructor(
        private dialog:MdDialog,
        private licenseService:LicenseService,
        private appLoader:AppLoaderService,
        private adalService:AdalService,
        private router:Router,
        private route:ActivatedRoute,
        private exportService:ExportToCSVService,
        private pagerService:PagerService,
        private userService:UserService,
    ){
        if (!this.adalService.getCachedToken()) {
            setTimeout(() => {
                this.router.navigate(["login"]);
            }, 100);
        }
            appLoader.close();
            route.params.subscribe((params)=>{
                this.ProductId=params['productId']
            })
            this.getUserRights();
            this.getLicenseDetail();
       
    }
    setPage(page: number) {
        this.gltLicenseDisplayDetail=[...this.originalGltLicenseDisplayDetail];
        this.applySort();
        this.pager = this.pagerService.getPager(this.gltLicenseDisplayDetail.length, page);
        this.pagedItems = this.gltLicenseDisplayDetail.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
    openGenerateKeyDialog(){
        let gltGenerateKeyDialogRef:MdDialogRef<GenerateGltLicenseComponent>=this.dialog.open(GenerateGltLicenseComponent,{
            width:'40%',
            disableClose:true,
            data:{
                gltLicenseData:this.originalGltLicenseDisplayDetail,
                SelectedLicenseDetail:null
            }
        })
        gltGenerateKeyDialogRef.afterClosed().subscribe((result)=>{
            this.originalGltLicenseDisplayDetail=result;
            this.gltLicenseDisplayDetail=[...this.originalGltLicenseDisplayDetail];
            this.setPage(1);
        })
    }
    getUserRights(){
        let UserId=Number(localStorage.getItem('userid'))
        this.userService.getUserLicenseRightById(UserId,this.ProductId).subscribe((data)=>{
            if(!data.IsError && data.DataObject!=null){
                this.IsAddEdit=data.DataObject.IsAddEdit;
                this.IsDelete=data.DataObject.IsDelete;
            }
        })
    }
    getLicenseDetail(){
        this.appLoader.open()
        this.licenseService.getGltLicenseDetail().subscribe((data)=>{
            if(!data.IsError && data.DataObject!=null){
                this.originalGltLicenseDisplayDetail=data.DataObject;
                this.gltLicenseDisplayDetail=[...this.originalGltLicenseDisplayDetail];
                this.setPage(1);
                this.appLoader.close();
            }
            else{
                this.error=data.Error;
                this.appLoader.close();
            }
        })
    }
    onEdit(row){
        let gltGenerateKeyEditDialogRef:MdDialogRef<GenerateGltLicenseComponent>=this.dialog.open(GenerateGltLicenseComponent,{
            width:"40%",
            disableClose:true,
            data:{
                gltLicenseData:this.originalGltLicenseDisplayDetail,
                SelectedLicenseDetail:row
            }
        })
        gltGenerateKeyEditDialogRef.afterClosed().subscribe((result)=>{
            this.originalGltLicenseDisplayDetail=result;
            this.gltLicenseDisplayDetail=[...this.originalGltLicenseDisplayDetail];
            this.setPage(this.pager.currentPage);
        })
    }
    exportToCSV(){
       let jsonData:Array<any>=[];
            if(this.gltLicenseDisplayDetail){
                this.gltLicenseDisplayDetail.forEach(element => {
                    jsonData.push({
                        Customer:element.CustomerName,
                        TabletSerialNo:element.TabletSerialNo,
                        'Unique H/W Id':element.CustomerUniqueKey,
                        LicenseKey:element.LicenseKey,
                        SUAExpirationDate:element.SUAExpirationDate
                    })
                });
                this.exportService.exportToCsv(jsonData,'GLT')
            }
            else{
                Swal.fire({
                    title:'No data',
                    text:'There is no data available to export to CSV file.',
                    showCloseButton:true,
                    showConfirmButton:true,
                    confirmButtonColor:'#FFCA28'
                })
            } 
    }

    onSortChange(event){
        this.currentSortColumn = event.column;
        this.currentSortOrder = event.order;
        this.setPage(this.pager.currentPage);
    }
    applySort(){
        if(!this.currentSortColumn || !this.currentSortOrder) return;
        this.gltLicenseDisplayDetail=this.gltLicenseDisplayDetail.sort((a,b)=>
            {
                if(this.currentSortOrder==='asc'){
                    return a[this.currentSortColumn].localeCompare(b[this.currentSortColumn])
                }
                else if (this.currentSortOrder==='desc'){
                    return b[this.currentSortColumn].localeCompare(a[this.currentSortColumn])
                }
                else {
                    return 0;
                }
            }
        )
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/glt/glt.component.ts